export enum AsyncTaskItemStatus {
	PENDING = 'PENDING',
	SUBMITTED = 'SUBMITTED',
	SUCCESS = 'SUCCESS', 
	FAIL = 'FAIL'
}